import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { SlidePanel } from '@/components/ui/slide-panel';

interface DeleteInstallerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void>;
  installerName: string;
}

export function DeleteInstallerDialog({ 
  open, 
  onOpenChange, 
  onConfirm, 
  installerName 
}: DeleteInstallerDialogProps) {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <SlidePanel
      isOpen={open}
      onClose={() => onOpenChange(false)}
      title="Delete Installer"
      width="sm"
      topOffset="4.5rem"
      showEdgeCloseButton={true}
    >
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">
          Are you sure you want to delete the installer "{installerName}"? This action cannot be undone.
        </p>
        <div className="flex flex-col-reverse sm:flex-row gap-2 pt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleConfirm} disabled={isDeleting}>
            Delete Installer
          </Button>
        </div>
      </div>
    </SlidePanel>
  );
}